import Framework from '@greenville/framework';
import { applySnapshot, types } from 'mobx-state-tree';
import * as constants from '../../../common/constants';

const chartsListData = types.model('chartsListData', {
  type: types.maybeNull(types.string),
  feedback: types.maybeNull(types.string),
  bookId: types.maybeNull(types.string),
  feedbackId: types.maybeNull(types.string),
  content: types.maybeNull(types.string),
  userId: types.maybeNull(types.string),
  comments: types.maybeNull(types.string),
  reasonForDislike: types.maybeNull(types.string),
  serverDateTime: types.maybeNull(types.string)
});

const AIFeedbackChartsDetailsModel = types
  .model('AIFeedbackChartsDetailsModel', {
    status: types.maybeNull(types.string),
    data: types.optional(types.array(chartsListData), [])
  })
  .actions((self) => ({
    fetch(payload) {
      Framework.getEventManager().publish(constants.GET_AI_CHARTS_UTILITY_LIST_DATA, {
        payload
      });
    },
    setResponse(response) {
      applySnapshot(self, response);
      Framework.getEventManager().publish(constants.SET_AI_CHARTS_UTILITY_LIST_DATA);
    },
    resetStoreValues() {
      const initialState = [];
      applySnapshot(self.data, initialState);
      Framework.getEventManager().publish(constants.SET_AI_CHARTS_UTILITY_LIST_DATA);
    }
  }));

export default AIFeedbackChartsDetailsModel;
